import { KazooError } from "@kazoohr/types";

/**
 * Asserts that `input` has been narrowed to `never` by exhaustively checking
 * all possible values. Use this to show that a switch statement or if-else
 * chain covers all cases and trigger a compile-time error if new cases are
 * added without being handled.
 */
/* istanbul ignore next */
export function assertUnreachable(
  input: never,
  errorMessage = "This should not be callable with any input."
): never {
  throw new KazooError(errorMessage, { input });
}
